var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlarms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "#2E3A59",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#2E3A59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7636 19.2748V19.4819L19.91 19.6283L22.5768 22.2951V22.9946H1.07129V22.2951L3.73803 19.6283L3.88448 19.4819V19.2748V12.2418C3.88448 8.08387 6.06941 4.72954 9.82942 3.83867L10.2141 3.74752V3.35214V2.39566C10.2141 1.50433 10.9327 0.785767 11.824 0.785767C12.7154 0.785767 13.4339 1.50433 13.4339 2.39566V3.35214V3.7472L13.8183 3.83858C17.5649 4.72939 19.7636 8.09839 19.7636 12.2418V19.2748ZM14.0823 25.4012C13.8519 26.4345 12.9236 27.2143 11.824 27.2143C10.7135 27.2143 9.79302 26.4355 9.56507 25.4012H14.0823Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarms);
export default __webpack_public_path__ + "static/media/alarms.78f016ae.svg";
export { ForwardRef as ReactComponent };